import React, { memo, useMemo } from 'react';
import { AtlasSvgPrimitive } from './AtlasSvgPrimitive.js';

// Apache, https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/master/design-system/checkbox/src/internal/checkbox-icon.tsx
function getIcon(isIndeterminate, isChecked) {
  if (isIndeterminate) {
    return /*#__PURE__*/React.createElement("rect", {
      fill: "inherit",
      x: "8",
      y: "11",
      width: "8",
      height: "2",
      rx: "1"
    });
  }
  if (isChecked) {
    return /*#__PURE__*/React.createElement("path", {
      d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
      fill: "inherit"
    });
  }

  // No icon
  return null;
}
const AtlasCheckboxIcon = /*#__PURE__*/memo(({
  size,
  isIndeterminate,
  isChecked
}) => {
  const icon = useMemo(() => getIcon(isIndeterminate, isChecked), [isIndeterminate, isChecked]);
  return /*#__PURE__*/React.createElement(AtlasSvgPrimitive, {
    label: "",
    size: size,
    primaryColor: "var(--checkbox-background-color)",
    secondaryColor: "var(--checkbox-tick-color)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: "6",
    y: "6",
    width: "12",
    height: "12",
    rx: "2"
  }), icon));
});
AtlasCheckboxIcon.displayName = 'AtlasCheckboxIcon';

export { AtlasCheckboxIcon };
